<script lang="ts" setup>
  const { user, image, firstName, lastName, email, logOut } =
    useUserStore();

  const { imagesURL } = useRuntimeConfig().public;
  const userImage = ref<string>(image);
  const fullName = ref<string>(`${firstName} ${lastName}`);
  watch(
    () => user?.profileImage,
    (newValue) =>
      (userImage.value = `${imagesURL}/uploads/${newValue}`),
  );
  watch(
    () => [user?.firstName, user?.lastName],
    ([newFirstName, newLastName]) => {
      fullName.value = `${newFirstName} ${newLastName}`.trim();
    },
  );
  const { t } = useI18n();
  const open = ref(false);

  const items = ref([
    {
      label: t("labels.settings"),
      icon: "heroicons-cog",
      path: "/settings",
      action: () => {
        open.value = false;
      },
    },
    {
      label: t("actions.logout"),
      icon: "heroicons-power",
      action: () => {
        logOut();
        navigateTo("/signin");
      },
    },
  ]);
</script>

<template>
  <UPopover v-model:open="open">
    <UButton
      color="neutral"
      variant="ghost"
      :aria-label="$t('actions.open-profile-menu')"
    >
      <UAvatar :src="userImage" size="lg" />
    </UButton>
    <template #content>
      <div
        class="grid w-56 divide-y divide-(--ui-border) overflow-hidden rounded-sm"
      >
        <div class="flex gap-2 overflow-hidden p-2.5 text-gray-900">
          <UAvatar :src="userImage" size="lg" />
          <div class="overflow-hidden wrap-break-word">
            <p class="text-sm font-medium">
              {{ fullName }}
            </p>
            <p class="text-xs text-ellipsis">{{ email }}</p>
          </div>
        </div>
        <UButton
          v-for="item in items"
          :label="item.label"
          :icon="item.icon"
          :to="item.path"
          @click="item.action"
          class="justify-start bg-transparent py-2.5 text-gray-700 hover:bg-gray-50"
        />
      </div>
    </template>
  </UPopover>
</template>

<style></style>
